import React from 'react';
import { SparkModalPortal, ModalFeedback } from '@spark';

/**
 * Modal shown before training when more than 10% of the active train-set
 * records are unlabeled (empty labels []). Lets the user proceed anyway or
 * jump to the Data Editor pre-filtered to the "Unlabeled" bucket.
 */
const UnlabeledDataWarningModal = ({
    visible,
    onCancel,
    onContinue,
    onReview,
    unlabeledCount = 0,
    total = 0,
    percent = 0,
}) => {
    return (
        <SparkModalPortal
            open={visible}
            onClose={onCancel}
            size="text"
        >
            <ModalFeedback
                feedbackType="warning"
                title="More than 10% of your dataset is unlabeled"
                content={`${percent}% (${unlabeledCount} samples out of ${total}) do not have labels and will be excluded from training. This may reduce the amount of information available to the model and affect training results.`}
                showClose
                showOverlay={false}
                primaryLabel="Continue"
                primaryDisableWhenReadOnly
                tertiaryLabel="Review Unlabeled"
                onCloseClick={onCancel}
                onPrimaryClick={onContinue}
                onTertiaryClick={onReview}
            />
        </SparkModalPortal>
    );
};

export default UnlabeledDataWarningModal;
